import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/base.css";
import "video.js/dist/video-js.css";

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
